export var printedPublicationTranslations = {
    "": { id: "ui-br-publishers.publishers.select.label.default" },
    SOFTCOVER: {
        id: "ui-br-publishers.publishers.workSpec.select.label.printedPublicationBinding.soft",
    },
    HARDCOVER: {
        id: "ui-br-publishers.publishers.workSpec.select.label.printedPublicationBinding.hard",
    },
    SOFT: {
        id: "ui-br-publishers.publishers.workSpec.select.label.printedPublicationBinding.soft",
    },
    HARD: {
        id: "ui-br-publishers.publishers.workSpec.select.label.printedPublicationBinding.hard",
    },
};
export var getPrintedPublicationTranslations = function (intl, key) {
    var translation = printedPublicationTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
